import styled from 'styled-components';
import { contentOverlayStylesWithOpacity } from '../../../commonStyles/contentOverlay';
import colors from '../../../helpers/colors';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import LogoLink, { LogoLinkProps } from '../../LogoLink';

export const desktopHeaderHeight = spacing(9.5);
export const navItemSelectedBarHeight = '4px';
export const HeaderOuter = styled.header`
  /* Should appear above all content, and overlay */
  z-index: 7;

  background-color: ${colors.core02};

  /* Position relative so that the menus can position themselves below the header. */
  position: relative;

  ${mediaQuery.tabletLandscape`
    border-bottom: ${colors.neutral06} solid ${navItemSelectedBarHeight};
  `}
`;

export const HeaderInner = styled.nav<{
  isFullWidth?: boolean;
  isDifferentBackgroundInMobile?: boolean;
}>`
  display: flex;
  max-width: ${({ isFullWidth }) => (isFullWidth ? '100%' : '1290px')};
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;

  padding: 0 ${spacing(2)};
  height: ${spacing(7)};
  background-color: ${({ isDifferentBackgroundInMobile }) =>
    isDifferentBackgroundInMobile ? colors.neutral08 : colors.core02};
  ${mediaQuery.tabletPortrait`
    height: ${spacing(8)};
  `}

  ${mediaQuery.tabletLandscape`
    align-items: stretch;
    padding: 0 ${spacing(3)};
    height: ${desktopHeaderHeight};
    background-color: ${
      colors.core02
    };                                                                
  `}
`;

interface LogoLinkBProps extends LogoLinkProps {
  isMobileLogo?: boolean;
}
export const headerItemFlex = 1;

export const Logo = styled(LogoLink)<LogoLinkBProps>`
  flex: ${headerItemFlex};
  display: ${({ isMobileLogo }) => (isMobileLogo ? 'none' : 'flex')};
  align-items: center;
  ${mediaQuery.tabletLandscape`
     display: flex;
    `}
  img {
    height: ${spacing(3)};

    ${mediaQuery.tabletPortrait`
      height: ${spacing(2)};
    `}

    ${mediaQuery.tabletLandscape`
      height: ${spacing(3.5)};
    `}
  }
`;

export const MobileLogo = styled(Logo)`
  display: flex;
  ${mediaQuery.tabletLandscape`
    display:none;
    `}
`;
type ContentOverlayProps = {
  activeMobile?: boolean;
  activeDesktop?: boolean;
};

const contentOverlayOpacity = 0.65;
export const ContentOverlay = styled.div<ContentOverlayProps>`
  z-index: 1; /* between the content and header */

  ${contentOverlayStylesWithOpacity(contentOverlayOpacity)}

  opacity: ${({ activeMobile }) => (activeMobile ? contentOverlayOpacity : 0)};
  transition: opacity 0.6s ease-out;

  /* Pass through clicks if the overlay is not active - we don't want it to interfere with
  the site interactivity. */
  pointer-events: ${({ activeMobile }) => (activeMobile ? 'auto' : 'none')};

  ${({ activeDesktop }) => mediaQuery.tabletLandscape`
    opacity: ${activeDesktop ? contentOverlayOpacity : 0};
    pointer-events: ${activeDesktop ? 'auto' : 'none'};
  `}
`;
